<div class="mainWraps">
    <div class="bgImageWrap">
        <img src="../../../assets/images/patch/industriesbg.png">
    </div>

    <div class="bgMobileImageWrap">
        <img src="../../../assets/images/IndustriesMobile.png">
    </div>

    <div class="overLay">
        <div class="textWraps">
            <div class="titleWraps">
                Industries We Served So Far
            </div>
            <div class="subTitleWrap">
                Leveraging the power of disruptive digital technologies, we empower businesses across industries to transform digitally
            </div>
           
        </div>
    </div>
</div>


<div class="service-provider">
    <div class="mainWrap">
        <div class="headerSection">
            <div class="descWrap">
                We deliver bespoke industry specific solutions leveraging our extensive digital experience, design-led engineering approach and agile processes backed by our strong expertise in cutting edge technologies.
            </div>
        </div>
        <div class="bodySection">
            
            <div class="bodyWrap">
                <div class="rowWrap" *ngFor="let i of extensiveReach">
                    <div class="card">
                        <img class="image" src="{{i.bgImageUrl}}">
                        <div class="overLay">
                           {{i.title}}
                        </div>
                    </div>
                </div>
            </div>


<!--             <div class="rowWrap" *ngFor = "let i of services">
                <div class="card">
                    <div class="imageWrap">
                        <img src="{{i.imageUrl}}">
                    </div>
                    <div class="textWrap">
                        <div class="titleRowWrap">
                           {{i.title}}
                        </div>
                        <div class="descRowWrap">
                           {{i.desc}}
                        </div>
                    </div>
                </div>
            </div> -->


        </div>
    </div>
</div>